import { initializeApp } from "firebase/app";
import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC8NWAbQyTb1XRq70gY7v2W2LUdvjBRlLg",
  authDomain: "open-source-28ce5.firebaseapp.com",
  projectId: "open-source-28ce5",
  storageBucket: "open-source-28ce5.appspot.com",
  messagingSenderId: "371280248581",
  appId: "1:371280248581:web:7a82e8bb17f778e888816c",
  measurementId: "G-21DBGPWW0V",
};

const app = initializeApp(firebaseConfig);

let db;
try {
  // Cache reads locally (IndexedDB) so repeat visits can render the widget config and
  // chat history from cache instantly while Firestore revalidates in the background,
  // instead of always paying a full network round trip first. Multi-tab manager since
  // this widget can be embedded in several iframes sharing the same origin at once.
  db = initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager(),
    }),
  });
} catch (error) {
  // Falls back to the default in-memory client if persistence can't be enabled
  // (e.g. third-party storage restrictions inside the embedding iframe).
  db = getFirestore(app);
}

export { db };
